import { defineComponent as _defineComponent } from 'vue'
import type { IconName } from '../WheelsSvgIcon/WheelsSvgIcon.types'
import WheelsSvgIcon from '../WheelsSvgIcon/WheelsSvgIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsButton',
  props: {
    variant: { default: 'primary' },
    icon: null,
    iconPosition: { default: 'left' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event:MouseEvent): void
}), expose: any, slots: any, attrs: any }) {





function handleClick(event:MouseEvent) {
  emit('click', event)
}


return { __sfc: true,emit, handleClick, WheelsSvgIcon }
}

})